import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';

interface SelectProps {
  selectedTask: any,
  setSelectedTask: any,
  category: any
}


const SelectTaskEdit: React.FC<SelectProps> = ({selectedTask, setSelectedTask, category }) => {
  const [task, setTask] = useState<any[]>([]);
  const initializedRef = useRef(false);

  const handleSelectChange = (selectedOptions: any) => {
    setSelectedTask(selectedOptions);
  };

  useEffect(() => {
    (async () => {
      try {
        const { data: taskData } = await axios.get('task');
        const sortedCategories = taskData.sort((a: any, b: any) => a.name.localeCompare(b.name));
        const formattedCategory = sortedCategories
        .filter((task: any) => task.active)
        .map((task: any) => ({
          value: task.id,
          label: task.name,
        }));
        setTask(formattedCategory);
      } catch (e) {
      }
    })();
  }, []);

  // Initialize selectedTask from category only once when category loads
  useEffect(() => {
    if (category && category.task && !initializedRef.current) {
      initializedRef.current = true;
      const formattedTasks = category.task
        .filter((task: any) => task.active)
        .map((task: any) => ({
          value: task.id,
          label: task.name,
        }));
      setSelectedTask(formattedTasks);
    }
  }, [category, setSelectedTask]);

  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      name="colors"
      placeholder='Select Tasks...'
      value={selectedTask}
      onChange={handleSelectChange}
      options={task}
      className="basic-multi-select w-full task-edit-fix bg-[var(--bg-input)] text-left"
      classNamePrefix="select"
    />
  )
}

export default SelectTaskEdit
